<template>
  <div class="main" v-loading = "isLoading">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="月报"  />
      <xy-toolbox-menu class="r"  >
          <xy-toolbox-menu-item icon="excel" @click="exportExcel">导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
   
    <div  style="margin-top:20px;">
      <xy-toolbox-menu>  
          <xy-toolbox-menu-item custom style="width:450px;">
        <div class="custom-content">

    <el-date-picker
      v-model="value2"
      type="monthrange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      :picker-options="pickerOptions">
    </el-date-picker>

    <el-button style="margin-left:20px;" @click="getReport">生成报告</el-button>
        </div>
        
        </xy-toolbox-menu-item>
 
      </xy-toolbox-menu>

      </div>


        <div  style="margin:auto;overflow: auto;" v-show="monthlyReportList.length>0" >
             <el-table border fit :data="monthlyReportList"  stripe  tooltip-effect="dark"   height="700" style="width:99.9%;white-space:nowrap;">
             <el-table-column :label="item" :prop="item" v-for="(item, index) in columns" :key="index"  >
     

             </el-table-column>
              <!-- <el-table-column :label="item" :key="index" v-for="(item, index) in columns">
   
                 </el-table-column> -->
            </el-table>
        </div>  
 </div> 
</template>

<script>
  import {
    mapMutations,
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';

import Permissions from  '../../store/permissions.js'
 export default {
    name: 'monthlyreport',
   
    data() {
      return {
        loading:false,
    
     pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近二个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 2);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',
        columns:[],
      }
    },
    methods:{
    ...mapMutations('reports', ['setMonthlyReportList']),
      ...mapActions('reports', ['loadMonthlyReport']),
      getReport(){        
          this.loadMonthlyReport({start:this.value2[0],end:this.value2[1]});
      },
      exportExcel(){
         if(!Permissions.Client_ViewReport_Month_Down  ())
            {
               this.$message({ message: "没有下载权限。", duration: 2000 });
               return ;
            }
            JSONToExcel(this.monthlyReportList, "月报", "monthly_report");
      }

    },
    
     computed: {
      ...mapGetters('reports', {'monthlyReportList': 'monthlyReportList'}),
      ...mapState({ isLoading: state => state.loadingCount > 0}),
     },
     watch:{
     monthlyReportList(newValue){
       this.columns.length = 0;
       for(var x in newValue[0])
       {
           this.columns.push(x);

       }
      
   }

     }
}
</script>
<style .scoped>
.main .el-date-editor .el-range__icon {
    font-size: 14px;
    margin-left: 5px ;
    color: #C0C4CC;
    float: left;
    line-height: 32px; }
</style>